import React, { useContext, useEffect, useMemo, useState } from "react";
import Box from "../../../setupPage/SharedComponents/Box";
import SetupContainer from "../../../setupPage/SharedComponents/SetupContainer";
import { contextProvider } from "../../../setupPage/SetupPagesContextApi/SetupPagesContextApi";
import SetupDropDown from "../../../setupPage/SharedComponents/SetupDropdown";
import axios from "axios";
import AdminBookingCard from "../SharedComponent/AdminBookingCard";
import PieChartComponenet from "../../UserDashboard/SharedComponents/PieChartComponenet";
import BarChartComponent from "../../UserDashboard/SharedComponents/BarChartComponent";
import BookingHistoryTable from "../../UserDashboard/SharedComponents/BookingHistoryTable";
import { dedupeBookingHistoryByParcel } from "../../../../utils/bookingHistory";

const flattenOverviewRows = (raw) => {
  const list = Array.isArray(raw) ? raw : [];
  return list.map((row) => {
    const details = Array.isArray(row?.details) ? row.details : [];
    const first = details[0] || {};
    const paymentStatus =
      row.paymentStatus ||
      first.paymentStatus ||
      row.statusName ||
      first.statusName;
    return {
      ...first,
      ...row,
      parcelNo: row.parcelNo ?? first.parcelNo,
      senderName: row.senderName || first.senderName,
      receiverName: row.receiverName || first.receiverName,
      senderEmail: row.senderEmail || first.senderEmail,
      receiverEmail: row.receiverEmail || first.receiverEmail,
      routeName: first.routeName || row.routeName,
      subTotal:
        row.currentInvoiceAmount ??
        row.subTotal ??
        first.subTotal,
      symbol: first.symbol || row.symbol || "GBP",
      paymentStatus,
      statusName: paymentStatus,
      currentParcelStatusName:
        row.currentParcelStatusName ||
        row.parcelStatusName ||
        first.currentParcelStatusName,
      parcelCreationDate: first.parcelCreationDate || row.parcelCreationDate,
    };
  });
};

const OverView = () => {
  const { parcelCount } = useContext(contextProvider);

  const backendUrl = process.env.REACT_APP_API_URL;
  const [fetchedData, setFetchedData] = useState(null);

  const [tableDate, setTableData] = useState(null);
  const [selectedParcel, setSelectedParcel] = useState(null);
  const [parcelStatusData, setParcelStatusData] = useState(null);
  const [statusLoading, setStatusLoading] = useState(false);

  const [bookingUserTypeUrl, setBookingUserTypeUrl] = useState(
    "ParcelBookingInformation/ParcelBookingHistory"
  );
  useEffect(() => {
    axios
      .get(backendUrl + bookingUserTypeUrl)
      .then((res) => {
        const rows = dedupeBookingHistoryByParcel(
          flattenOverviewRows(res.data),
        );
        setFetchedData(rows);
        setTableData(rows);
      })
      .catch((err) => console.log(err.message));
  }, [backendUrl, bookingUserTypeUrl]);

  useEffect(() => {
    if (!selectedParcel) {
      setParcelStatusData(null);
      setStatusLoading(false);
      return;
    }
    setStatusLoading(true);
    axios
      .get(
        `${backendUrl}ParcelStatus/GetParcelStatusRankByParcelId?parcelId=${selectedParcel}`,
      )
      .then((res) => {
        setParcelStatusData(res.data);
        setStatusLoading(false);
      })
      .catch(() => {
        setParcelStatusData(null);
        setStatusLoading(false);
      });
  }, [selectedParcel, backendUrl]);

  const parcelCountName = (id) => {
    if (id === 0) return "User Parcel Count";
    if (id === 1) return "Agent Parcel Count";
    if (id === 2) return "Total Parcel Count";
  };

  const [dropDownText, setDropDownText] = useState("");
  const dropDownHandle = (text) => {
    setDropDownText(text);
    setSelectedParcel(null);
    if (text === "All")
      setBookingUserTypeUrl("ParcelBookingInformation/ParcelBookingHistory");
    if (text === "Agent")
      setBookingUserTypeUrl(
        "ParcelBookingInformation/ParcelAgentBookingHistory",
      );
  };

  const historyRows = useMemo(
    () => tableDate || fetchedData || [],
    [tableDate, fetchedData],
  );

  let piChartData = [
    { name: "Limit", value: 30, color: "#f05924" },
    { name: "Remaining", value: 20, color: "#27d99f" },
    { name: "going", value: 40, color: "#feca64" },
  ];

  return (
    <div>
      <Box top>
        <div className="mb-6">
          <p className="text-xs font-bold uppercase tracking-[0.16em] text-orange-600">
            Overview
          </p>
          <h1 className="text-2xl lg:text-3xl font-semibold tracking-tight text-stone-900 mt-1">
            Admin Dashboard
          </h1>
        </div>
        <SetupContainer>
          <div className="flex lg:items-start items-stretch justify-between gap-5 lg:flex-row flex-col">
            <div className="w-full min-w-0">
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
                {parcelCount?.length > 0 &&
                  Object?.keys(parcelCount[0])?.map((item, idx) => {
                    return (
                      <AdminBookingCard
                        key={item}
                        name={parcelCountName(idx)}
                        value={parcelCount[0][item]}
                      />
                    );
                  })}
              </div>
              <div className="mt-5 rounded-2xl border border-stone-200 bg-white p-4 shadow-sm admin-chart-card">
                <BarChartComponent />
              </div>
            </div>
            <div className="w-full lg:w-[320px] shrink-0 rounded-2xl border border-stone-200 bg-white p-2 shadow-sm admin-chart-card">
              <PieChartComponenet
                limit={100}
                remaining={20}
                data={piChartData}
                tittle="Admin Booking"
              />
            </div>
          </div>

          {/* <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 mt-6 lg:mt-16 lg:gap-20">
            {parcelCountDimension?.map((item, idx) => {
              return (
                <div
                  key={idx}
                  className="shadow-sm gap-4 py-5  min-h-52  rounded-lg bg-gradient-to-tr from-[#d6d4b6d8] to-[#cacac2] flex items-center flex-col"
                >
                  <div className=" flex justify-start items-center   flex-col">
                    <img
                      className="w-[50px] h-[40px] object-contain"
                      src={parcelImageFormate(item.boxName)}
                      alt="parcel icon"
                    />
                    <h1 className="font-bold mt-1">
                      {parcelBoxNameFormate(item.boxName)}
                    </h1>
                  </div>
                  <div className="w-[70%]">
                    <h1 className="flex items-center justify-between  w-full text-lg font-semibold">
                      <span className="flex items-center gap-2 font-semibold">
                        <FaRegUser className="text-2xl" /> User Parcel
                      </span>{" "}
                      <span>{item.userBoxParcelCount}</span>
                    </h1>
                    <h1 className="flex items-center justify-between  w-full text-lg font-semibold mt-3">
                      <span className="flex items-center gap-2 font-semibold">
                        <FaUserTie className="text-2xl" /> Agent Parcel
                      </span>{" "}
                      <span>{item.agentBoxParcelCount}</span>
                    </h1>
                    <div className="border-b-black w-full border mt-2"></div>
                    <h1 className="flex items-center justify-between  w-full text-lg font-semibold mt-1">
                      <span className="flex items-center gap-2 font-semibold">
                        Total Parcel
                      </span>{" "}
                      <span>{item.totalBoxParcelCount}</span>
                    </h1>
                  </div>
                </div>
              );
            })}
          </div> */}
        </SetupContainer>
      </Box>
      <Box>
        <div className="rounded-2xl border border-stone-200 bg-white p-4 sm:p-5 shadow-sm">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 mb-4">
          <div>
            <p className="text-xs font-bold uppercase tracking-[0.16em] text-orange-600">
              Parcels
            </p>
            <h2 className="text-xl font-semibold text-stone-900 mt-0.5">
              Booking history
            </h2>
          </div>
          <div className="w-full sm:w-[220px]">
            <SetupDropDown
              dataOf="bookingUserType"
              allTimeValue={dropDownText}
              defaultValue="All"
              valueUpdate={(e) => dropDownHandle(e.target.value)}
              name="branchId"
            ></SetupDropDown>
          </div>
        </div>
        <SetupContainer>
          <BookingHistoryTable
            data={historyRows}
            onSelectParcel={(parcel) => {
              setSelectedParcel(parcel?.parcelNo ?? null);
            }}
            selectedParcel={selectedParcel}
            parcelStatusData={parcelStatusData}
            statusLoading={statusLoading}
            embedded
            showRefund={false}
            showAmendmentDetails
            showCarrierPartner
          />
        </SetupContainer>
        </div>
      </Box>
    </div>
  );
};

export default OverView;
